import { render, staticRenderFns } from "./AdminOrderJson.vue?vue&type=template&id=7fef1eff"
import script from "./AdminOrderJson.vue?vue&type=script&lang=js"
export * from "./AdminOrderJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports